export default __webpack_public_path__ + "static/media/ic-jpg.3871d261.svg";